
import * as ItemSettings from "../types/ItemSettings"; 



export const createItemSettings = (type:string):any => {
	return settingsFactories[type]();
}


const Answer = ():ItemSettings.Answer => {
	return {};
};

const Checkboxes = ():ItemSettings.Checkboxes => {
	return {
		options: [ "" ]
	};
};

const Dropdown = ():ItemSettings.Dropdown => {
	return {
		options: [ "" ]
	};
};

const MultipleChoice = ():ItemSettings.MultipleChoice => {
	return {
		options: [ "" ]
	};
};

const LinearScale = ():ItemSettings.LinearScale => {
	return {
		// label: "",
		columns: [ "", "", "" ],
		rows: [ "" ]
	};
};

const Information = ():ItemSettings.Information => {
	return {
		title:"",
		text:""
	}
};

const HTML = ():ItemSettings.HTML => {
	return {
		content:""
	}
};


const settingsFactories:{ [k:string]:() => void } = {
	Answer,
	Checkboxes,
	Dropdown,
	MultipleChoice,
	LinearScale,
	Information,
	HTML	
};